







































































































































import { Mixins, Component, Watch } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import GameModule from '@/store/modules/Game';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {
    Table,
  },
})
export default class GameVersion extends Mixins(ErrorHandleMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Game name',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Version',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Maintenance status',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Type',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Action',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Manage version',
        attr: {
          class: 'text-left',
        },
      },
    ],
  ];

  GameInstance = getModule(GameModule, this.$store);

  data = [];

  action = false;

  version = false;

  isModalSocket = false;

  statusMaintenance = '0';

  url = '';

  prefix = '';

  socketStatus = [];

  partnerList = [];

  partnerType = 'all';

  @Watch('data')
  watchvalue(val) {
    this.socketStatus = val.filter((s: any) => [900, 901].includes(s.status));
  }

  created() {
    this.fetchGame();
  }

  async fetchGame() {
    this.GeneralInstance.toggleLoading(true);
    const partner = {
      partner: this.partnerType === 'ASKMESLOT' ? 'AMBSLOT' : this.partnerType,
    };
    const res = await this.GameInstance.FetchGame(partner);
    if (res.code) {
      this.checkError(res);
    } else {
      this.data = res.games;
      this.partnerList = res.partner;
    }
    this.GeneralInstance.toggleLoading(false);
  }

  editAction(val) {
    this.prefix = val.prefix;
    this.action = true;
  }

  editVersion(val) {
    this.prefix = val.prefix;
    this.url = val.url;
    this.version = true;
  }

  async handleMaintanence(val) {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.GameInstance.GameMaintenance({ code: val, prefix: this.prefix });
    if (res.code === 0) {
      if (val === '0') {
        this.GameInstance.MaintenanceGamesSocket({ prefix: this.prefix, isMaintenance: false });
      } else if (['900', '901'].includes(val)) {
        this.GameInstance.MaintenanceGamesSocket({ prefix: this.prefix, isMaintenance: true });
      }
      this.checkError(res);
    } else {
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: res.message,
        alertColor: res.code === 0 ? 'success' : 'danger',
      });
    }
    this.action = false;
    this.fetchGame();
    this.GeneralInstance.toggleLoading(false);
  }

  async handleVersion(val) {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.GameInstance.GameVersion({ url: val, prefix: this.prefix });
    if (res.code === 0) {
      this.checkError(res);
    } else {
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: res.message,
        alertColor: res.code === 0 ? 'success' : 'danger',
      });
    }
    this.version = false;
    this.fetchGame();
    this.GeneralInstance.toggleLoading(false);
  }

  async maintenanceAll() {
    this.GeneralInstance.toggleLoading(true);
    const statusGames = this.data.filter((s: any) => [900, 901].includes(s.status));
    if (statusGames.length >= 1) {
      const res = await this.GameInstance.MaintenanceAllSocket({
        isMaintenance: false,
        provider: this.partnerType,
      });
      this.checkError(res);
    } else {
      const res = await this.GameInstance.MaintenanceAllSocket({
        isMaintenance: true,
        provider: this.partnerType,
      });
      this.checkError(res);
    }
    this.fetchGame();
    this.toggleModal();
    this.GeneralInstance.toggleLoading(false);
  }

  handleChange() {
    this.fetchGame();
  }

  toggleModal() {
    this.isModalSocket = !this.isModalSocket;
  }
}
